(() => {
  'use strict';

  const root = document.querySelector('[data-pw-cart-config]');
  if (!root || root.dataset.pwStepLoaderReady === 'true') return;
  root.dataset.pwStepLoaderReady = 'true';

  const actions = root.querySelector('.pw-cart-config__actions');
  const next = root.querySelector('[data-pw-next]');
  const back = root.querySelector('[data-pw-back]');
  const status = root.querySelector('[data-pw-status]');
  if (!actions || !next) return;

  const style = document.createElement('style');
  style.textContent = `
    .pw-cart-step-loader{margin:14px 0 0;padding:14px 16px;border:1px solid #dedede;background:#fafafa;line-height:1.45}
    .pw-cart-step-loader[hidden]{display:none!important}
    .pw-cart-step-loader strong,.pw-cart-step-loader span{display:block}
    .pw-cart-step-loader strong{margin:0 0 3px;font-size:14px;color:#1f1f1f}
    .pw-cart-step-loader span{font-size:12px;color:#666}
    .pw-cart-config.is-processing .pw-cart-config__actions{opacity:.62}
    .pw-cart-config.is-processing .pw-cart-config__actions button{cursor:wait}
    [data-pw-progress="3"],[data-pw-step="3"]{display:none!important}
  `;
  document.head.appendChild(style);

  const loader = document.createElement('div');
  loader.className = 'pw-cart-step-loader';
  loader.setAttribute('role','status');
  loader.setAttribute('aria-live','polite');
  loader.hidden = true;
  loader.innerHTML = '<strong>Even uw keuzes verwerken…</strong><span>We slaan alleen de noodzakelijke bezorg- en servicekeuzes op.</span>';
  actions.parentNode.insertBefore(loader, actions);

  let active = false;
  let startedAt = 0;
  let failSafeTimer = null;
  let initialStep = '';
  const currentStep = () => root.querySelector('[data-pw-step].is-active')?.dataset.pwStep || '';
  const selectedMode = () => root.querySelector('[data-pw-mode]:checked')?.value || root.dataset.currentMode || '';
  const restrictedGroups = new Set(['installation','connection']);
  const groupOf = input => String(input?.dataset?.serviceGroup || input?.dataset?.pwServiceGroup || '').toLowerCase();

  function showLoader(){
    active = true;
    startedAt = Date.now();
    initialStep = currentStep();
    loader.hidden = false;
    root.classList.add('is-processing');
    root.setAttribute('aria-busy','true');
    next.disabled = true;
    if(back) back.disabled = true;
    clearTimeout(failSafeTimer);
    failSafeTimer = setTimeout(hideLoader,20000);
  }

  function hideLoader(){
    if(!active) return;
    const finish = () => {
      active = false;
      loader.hidden = true;
      root.classList.remove('is-processing');
      root.setAttribute('aria-busy','false');
      next.disabled = false;
      if(back) back.disabled = false;
      clearTimeout(failSafeTimer);
    };
    const left = 180 - (Date.now()-startedAt);
    if(left>0) setTimeout(finish,left); else finish();
  }

  function syncButtons(){
    const step = currentStep();
    if(step === '1') next.textContent = selectedMode() === 'pickup' ? 'Verder naar afrekenen' : 'Verder naar stap 2';
    if(step === '2') next.textContent = 'Verder naar afrekenen';
  }

  function syncPlacement(){
    const placement = root.querySelector('[data-pw-placement-block]');
    const mode = selectedMode();
    if(placement) placement.hidden = !mode || mode === 'pickup';
    root.querySelectorAll('[data-pw-placement-device]').forEach(device => {
      const level = device.querySelector('[data-pw-place]:checked')?.value || '';
      const floors = device.querySelector('[data-pw-floor-wrap]');
      if(floors) floors.hidden = level !== 'stairs';
    });
  }

  function syncGas(choice,clear=false){
    if(!choice) return;
    const yes = choice.querySelector('.pw-gas-choice__question input[type="radio"]:checked')?.value === 'yes';
    const options = choice.querySelector('.pw-gas-options');
    if(options){
      options.hidden = !yes;
      if(yes) options.style.removeProperty('display');
      else options.style.setProperty('display','none','important');
    }
    if(!yes && clear) choice.querySelectorAll('.pw-gas-options [data-pw-service-variant]').forEach(i => i.checked=false);
  }

  function syncServiceMode(){
    const fullService = selectedMode() === 'install';
    root.querySelectorAll('[data-pw-service-device] [data-pw-service]').forEach(input => {
      if(!restrictedGroups.has(groupOf(input))) return;
      const card = input.closest('.pw-service-option,label');
      if(!fullService) input.checked = false;
      if(card){
        card.hidden = !fullService;
        if(!fullService) card.style.setProperty('display','none','important');
        else card.style.removeProperty('display');
      }
    });
    if(fullService){
      root.querySelectorAll('[data-pw-install],[data-service-group="connection"]').forEach(input => {
        if(!input.disabled) input.checked = true;
      });
    }
    const stepTwo = root.querySelector('[data-pw-step="2"]');
    const copy = stepTwo?.querySelector('.pw-config-heading p');
    if(copy) copy.textContent = fullService
      ? 'Bij Full service kiezen we automatisch de passende basisservice: aansluiten of inbouwen. Extra opties kunt u per apparaat aanpassen.'
      : 'Kies per apparaat alleen de gewenste extra serviceopties. Aansluiten en inbouwen horen uitsluitend bij Full service bezorgen.';
    stepTwo?.querySelectorAll('.pw-inline-info').forEach(info => {
      if(!String(info.textContent||'').toLowerCase().includes('meerdere apparaten met inbouw')) return;
      info.hidden = !fullService;
      if(!fullService) info.style.setProperty('display','none','important');
      else info.style.removeProperty('display');
    });
  }

  const previousFetch = window.fetch.bind(window);
  window.fetch = async (input,init={}) => {
    const url = typeof input === 'string' ? input : String(input?.url || '');
    let nextInit = init;
    if(selectedMode() !== 'install' && /\/cart\/add\.js(?:\?|$)/.test(url) && typeof init.body === 'string'){
      try{
        const payload = JSON.parse(init.body);
        if(Array.isArray(payload?.items)){
          payload.items = payload.items.filter(item => {
            const group = String(item?.properties?.['_pw_service_group'] || item?.properties?.['_Servicegroep'] || '').toLowerCase();
            return !restrictedGroups.has(group);
          });
          nextInit = {...init,body:JSON.stringify(payload)};
        }
      }catch(_){ }
    }
    return previousFetch(input,nextInit);
  };

  next.addEventListener('click',() => {
    if(active) return;
    showLoader();
    requestAnimationFrame(() => {
      if(status?.classList.contains('is-error')) hideLoader();
    });
  },true);

  root.addEventListener('change',event => {
    const target = event.target;
    if(target.matches('[data-pw-mode]')){
      syncServiceMode();
      syncPlacement();
      syncButtons();
      event.stopPropagation();
      return;
    }
    if(target.matches('[data-pw-place],[data-pw-floors]')){
      syncPlacement();
      event.stopPropagation();
      return;
    }
    if(target.closest('[data-pw-gas-choice]') && target.matches('.pw-gas-choice__question input[type="radio"]')){
      syncGas(target.closest('[data-pw-gas-choice]'),target.value==='no');
      event.stopPropagation();
      return;
    }
    if(target.matches('[data-pw-service],[data-pw-service-variant]')){
      event.stopPropagation();
    }
  },true);

  const observer = new MutationObserver(() => {
    const step = currentStep();
    syncButtons();
    if(active && step !== initialStep) hideLoader();
    if(step === '3') window.location.assign('/checkout');
  });
  root.querySelectorAll('[data-pw-step]').forEach(step => observer.observe(step,{attributes:true,attributeFilter:['class']}));
  if(status) observer.observe(status,{attributes:true,attributeFilter:['class']});

  if(back) back.addEventListener('click',() => setTimeout(syncButtons,0));
  window.addEventListener('pageshow',hideLoader);

  syncPlacement();
  root.querySelectorAll('[data-pw-gas-choice]').forEach(choice => syncGas(choice,false));
  syncServiceMode();
  syncButtons();
  [80,300,800].forEach(delay => setTimeout(() => { syncServiceMode(); syncPlacement(); syncButtons(); },delay));
})();
